import { Tabs, TabsProps } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import LeavesSettings from "./LeavesSettings/LeavesSettings";
import WorkingPattern from "./WorkingPattern/WorkingPattern";
import GeneralSettings from "./GeneralSettings/GeneralSettings";
import { useNavigate, useSearchParams } from "react-router-dom";

import "./Settings.scss";
import LocationsSettings from "./LocationsSettings/LocationsSettings";
import OvertimeSettings from "./Overtime/Overtime";
import WorkSectors from "./WorkSectors/WorkSectors";
import SuperAdminPermissions from "./SuperAdminPermissions/SuperAdminPermissions";
import ClientFeatures from "./ClientFeatures/ClientFeatures";
import { useSelector } from "react-redux";
import { isSuperAdmin } from "../../utils/permissions";
import BusinessCategoriesSettings from "./BusinessCategoriesSettings/BusinessCategoriesSettings";
import InvestmentCategoriesSettings from "./InvestmentCategoriesSettings/InvestmentCategoriesSettings";
import AccessProfiles from "./AccessProfiles/AccessProfiles";
import UserPermissions from "./UserPermissions/UserPermissions";
import { usePermissions } from "../../utils/usePermissions";
import Clients from "./Clients/Clients";
import CompanyContracts from "./CompanyContracts/CompanyContracts";
import DocumentsSettings from "./DocumentsSettings/DocumentsSettings";
import EfaktureSettings from "./EfaktureSettings/EfaktureSettings";
import OctopusSettings from "./OctopusSettings/OctopusSettings";
type Props = {};
const Settings: React.FC<Props> = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<any>("general");
  const [searchParams, setSearchParams] = useSearchParams();
  const userData = useSelector((state: any) => state.userData.user);
  const { hasPermission } = usePermissions();

  searchParams.get("tab");
  useEffect(() => {
    const tabValue = searchParams.get("tab");
    setActiveTab(tabValue);
    if (!tabValue) {
      navigate(`/settings?tab=general`);
    }
    // navigate(`/settings?tab=${key}`);
  }, [activeTab, searchParams]);

  const tabPermissionMap: Record<string, string[]> = {
    general: [
      "settings-general:update-company",
      "settings-general:update-currency",
    ],
    Locations: ["settings-locations:view"],
    workingPattern: ["settings-working-pattern:view"],
    Leaves: ["settings-leaves:view"],
    Overtimes: ["settings-overtimes:view"],
    WorkSectors: ["settings-work-sectors:view"],
    BusinessCategories: ["settings-business-categories:view"],
    InvestmentCategories: ["investments:view"],
    CompanyContracts: ["settings-company-contracts:view"],
    DocumentsAccess: ["settings-documents:manage"],
    EfaktureTokens: ["invoices:view"],
    OctopusTokens: ["settings-daily-revenue:view"],
    AccessProfiles: ["settings-super-admin:assign", "settings:manage-permissions"],
    UserPermissions: ["settings-super-admin:assign", "settings:manage-permissions"],
    clientFeatures: ["settings-client-features:update"],
    superAdmin: ["settings-super-admin:assign"],
    clients: ["settings-super-admin:assign"],
  };

  const baseItems: TabsProps["items"] = [
    { key: "general", label: t("General"), children: <GeneralSettings /> },
    {
      key: "Locations",
      label: t("Locations"),
      children: <LocationsSettings />,
    },
    {
      key: "workingPattern",
      label: t("Working Pattern"),
      children: <WorkingPattern />,
    },
    { key: "Leaves", label: t("Leaves"), children: <LeavesSettings /> },
    { key: "Overtimes", label: t("Overtimes"), children: <OvertimeSettings /> },
    { key: "WorkSectors", label: t("Work Sectors"), children: <WorkSectors /> },
    {
      key: "BusinessCategories",
      label: t("Business Categoris"),
      children: <BusinessCategoriesSettings />,
    },
    {
      key: "InvestmentCategories",
      label: t("Investment Categories"),
      children: <InvestmentCategoriesSettings />,
    },
    {
      key: "CompanyContracts",
      label: t("Company Contracts"),
      children: <CompanyContracts />,
    },
    {
      key: "DocumentsAccess",
      label: t("Documents"),
      children: <DocumentsSettings />,
    },
    {
      key: "EfaktureTokens",
      label: "eFakture tokeni",
      children: <EfaktureSettings />,
    },
    {
      key: "OctopusTokens",
      label: "Octopus tokeni",
      children: <OctopusSettings />,
    },
    {
      key: "AccessProfiles",
      label: t("Access Profiles"),
      children: <AccessProfiles />,
    },
    {
      key: "UserPermissions",
      label: t("User Permissions"),
      children: <UserPermissions />,
    },
    ...(isSuperAdmin(userData?.roles)
      ? [
          {
            key: "clients",
            label: t("Clients"),
            children: <Clients />,
          },
          {
            key: "clientFeatures",
            label: t("Client Features"),
            children: <ClientFeatures />,
          },
          {
            key: "superAdmin",
            label: t("Super Admin Permisions"),
            children: <SuperAdminPermissions />,
          },
        ]
      : []),
  ];

  const items = baseItems.filter((item) => {
    if (isSuperAdmin(userData?.roles)) return true;
    const keys = tabPermissionMap[item.key as string];
    if (!keys || keys.length === 0) return true;
    return keys.some((k) => hasPermission(k));
  });

  const onChange = (key: string) => {
    console.log(key);
    navigate(`/settings?tab=${key}`);
    setActiveTab(key);
  };
  return (
    <div className="mainContainer">
      <Tabs
        defaultActiveKey="1"
        activeKey={activeTab}
        items={items}
        onChange={onChange}
      />
    </div>
  );
};

export default Settings;
